import type { RouteObject } from 'react-router-dom';

export const publicRoutes: RouteObject[] = [
  {
    path: '/login',
    lazy: async () => {
      const m = await import('@/pages/auth/login.page');
      return { Component: m.LoginPage };
    },
  },
  {
    path: '/forgot-password',
    lazy: async () => {
      const m = await import('@/pages/auth/forgot-password.page');
      return { Component: m.ForgotPasswordPage };
    },
  },
];
